/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Sort_AscendingInputs */

const en_disp_sort_ascending = /** @type {(inputs: Disp_Sort_AscendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ascending, switch to descending`)
};

const de_disp_sort_ascending = /** @type {(inputs: Disp_Sort_AscendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufsteigend, auf absteigend umschalten`)
};

/**
* | output |
* | --- |
* | "Ascending, switch to descending" |
*
* @param {Disp_Sort_AscendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_sort_ascending = /** @type {((inputs?: Disp_Sort_AscendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Sort_AscendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_sort_ascending(inputs)
	return en_disp_sort_ascending(inputs)
});